import React, {Component} from 'react';


import { hebMonthName,setMonth} from '../../utils/calendarUtils'
import CalendarCell from './calendar_cell';

class Calendar extends Component {


    state = { 
        open:false,
        
        searchField_placeholder: '',
        calendarSection :1,
        startDay:null,
        endDay:null,
        startDayFormated:'',
        endDayFormated:'',
        currentMonth: 0,
        firstKey: 0,
        lastKey: 0,
        currentKey: 0,
        currentYear:0,
        currentMonthHebName:'', 
        w1 : [],
        w2 : [],
        w3 : [],
        w4 : [],
        w5 : [],
        w6 : []
    }


    

    nextMonth = () => {

        let nextKey = this.state.currentKey +1;
        if ( nextKey > this.state.lastKey ) {

            return;
        }

        let nextMonth = this.state.currentMonth;


        if ( this.state.currentMonth === 12) {
            nextMonth = 1;
            let nextYear = this.state.currentYear + 1;
            this.setState({currentYear:nextYear}); 
        } else {
            nextMonth = nextMonth + 1;
        }


        this.setState({currentMonth:nextMonth}); 
        this.setState({currentKey:nextKey}); 
        this.setState({currentMonthHebName: hebMonthName(nextMonth)}); 
        

        let calendarMonth = setMonth(nextMonth ,  this.props.currentYear);
        this.setState({ w1:calendarMonth.week1});
        this.setState({ w2:calendarMonth.week2});
        this.setState({ w3:calendarMonth.week3});
        this.setState({ w4:calendarMonth.week4});
        this.setState({ w5:calendarMonth.week5});
        this.setState({ w6:calendarMonth.week6});
    }


    prevMonth = () => {

        let prevKey = this.state.currentKey -1;
        if ( prevKey < this.state.firstKey ) {

            return;
        }

        let prevMonth = this.state.currentMonth -1;

        this.setState({currentMonth:prevMonth});       
        this.setState({currentKey:prevKey});   
        this.setState({currentMonthHebName: hebMonthName(prevMonth)}); 

        let calendarMonth = setMonth(prevMonth ,  this.props.currentYear);
        this.setState({ w1:calendarMonth.week1});
        this.setState({ w2:calendarMonth.week2});
        this.setState({ w3:calendarMonth.week3});
        this.setState({ w4:calendarMonth.week4});
        this.setState({ w5:calendarMonth.week5});
        this.setState({ w6:calendarMonth.week6});
    }


    componentDidMount = () => {      

        console.log('Calendar componentDidMount this.props', this.props)
        const firstMonthObj = this.props.entitlementMonths[0];

        let lastMonthObj = {key:0};
        if (this.props.entitlementMonths.length > 0) {
         lastMonthObj = this.props.entitlementMonths[ this.props.entitlementMonths.length -1];
        }


        if ( firstMonthObj != undefined) {
            const firstMonth = firstMonthObj.month;
            this.setState({firstKey: firstMonthObj.key});
            this.setState({currentKey: firstMonthObj.key});

            if (lastMonthObj.key != 0) 
                this.setState({lastKey: lastMonthObj.key});

            this.setState({currentMonth: firstMonth});
            this.setState({currentYear: this.props.currentYear});
            const hMonthName = hebMonthName(firstMonth);
            this.setState({currentMonthHebName: hMonthName});


            let calendarMonth = setMonth(firstMonth ,  this.props.currentYear);

            this.setState({ w1:calendarMonth.week1});
            this.setState({ w2:calendarMonth.week2});
            this.setState({ w3:calendarMonth.week3});
            this.setState({ w4:calendarMonth.week4});
            this.setState({ w5:calendarMonth.week5});
            this.setState({ w6:calendarMonth.week6});
        }

    }





    resetClear = () =>  { 
        this.resetAllDays();
        this.setState({ startDay: null});
        this.setState({ endDay: null});
        this.setState({ calendarSection: 1});
        this.props.resetClearCalendar();
    }


    isInRange(d) {
        if (d.TDate > this.state.startDay && d.TDate < this.state.endDay) {
            return true;
        } else {
            return false;
        }            
    }

     resetAllDays() {
        this.setState(prevState => ({
            w1: prevState.w1.map(
                obj  => {
                    let t = {};
                    Object.assign(t, obj);
                    t.selected = false;
                    Object.assign(obj, t); 
                    return obj;
                }
            )
        }));

        this.setState(prevState => ({
            w2: prevState.w2.map(
                obj  => {
                    let t = {};
                    Object.assign(t, obj);
                    t.selected = false;
                    Object.assign(obj, t); 
                    return obj;
                }
            )
        }));        

        this.setState(prevState => ({
            w3: prevState.w3.map(
                obj  => {
                    let t = {};
                    Object.assign(t, obj);
                    t.selected = false;
                    Object.assign(obj, t); 
                    return obj;
                }
            )
        }));         

        this.setState(prevState => ({
            w4: prevState.w4.map(
                obj  => {
                    let t = {};
                    Object.assign(t, obj);
                    t.selected = false;
                    Object.assign(obj, t); 
                    return obj;
                }
            )
        }));          

        this.setState(prevState => ({
            w5: prevState.w5.map(
                obj  => {
                    let t = {};
                    Object.assign(t, obj);
                    t.selected = false;
                    Object.assign(obj, t); 
                    return obj;
                }
            )
        }));          

        this.setState(prevState => ({
            w6: prevState.w6.map(
                obj  => {
                    let t = {};
                    Object.assign(t, obj);
                    t.selected = false;
                    Object.assign(obj, t); 
                    return obj;
                }
            )
        }));  
     }




    setDayCell = (selectedDay) => {
        this.setSelectedDate(selectedDay);

    }

    setSelectedDate = (d) => {

        const chk = !d.selected;

        if (this.state.calendarSection === 3 ) {
            this.setState({ startDay: null});
            this.setState({ endDay: null});
            this.setState({ startDayFormated: ''});
            this.setState({ endDayFormated: ''});
            this.setState({ calendarSection: 1});
            this.resetAllDays();
            

        } else {
            
            if (chk) {
                if (this.state.calendarSection === 1 ) {
                    this.setState({ calendarSection:2});
                    this.setState({ startDay:d.TDate});      
                    this.setState({ startDayFormated: d.date});          
                }

                if (this.state.calendarSection === 2 ) {

                    console.log(d.TDate );
                    if (d.TDate >= this.state.startDay) {
                        this.setState({ calendarSection:3});
                        this.setState({ endDay:d.TDate});   
                        this.setState({ endDayFormated: d.date});
                        
                    }  else {
                        return;
                    }        
                }
                d.selected = chk;
            } else {
                if (this.state.calendarSection === 2 ) {

                    if (d.TDate === this.state.startDay) {
                        d.selected = false;
                        this.setState({ calendarSection:1});

                    } else {
                        d.selected = true;
                        this.setState({ calendarSection:3});
                    }
                       
                }
                
            }

            
        
            this.setState(prevState => ({
                w1: prevState.w1.map(
                obj => (obj.key === d.key ? Object.assign(obj, d) : obj)
            )
            }));

            this.setState(prevState => ({
                w2: prevState.w2.map(
                obj => (obj.key === d.key ? Object.assign(obj, d) : obj)
            )
            }));

            this.setState(prevState => ({
                w3: prevState.w3.map(
                obj => (obj.key === d.key ? Object.assign(obj, d) : obj)
            )
            }));

            this.setState(prevState => ({
                w4: prevState.w4.map(
                obj => (obj.key === d.key ? Object.assign(obj, d) : obj)
            )
            }));

            this.setState(prevState => ({
                w5: prevState.w5.map(
                obj => (obj.key === d.key ? Object.assign(obj, d) : obj)
            )
            }));

            this.setState(prevState => ({
                w6: prevState.w6.map(
                obj => (obj.key === d.key ? Object.assign(obj, d) : obj)
            )
            }));
        }

        console.log(d);
    }    

    isDaySelected = (d)  => {
        if (d.selected) {
            return true;
        }
        return false;
    }



    getCssClass(d) {

        if (d.selected) {
            return "calendar_day_current_circle ponter";
        }

        if (this.isInRange(d) ) {
            return "calendar_day_in_range ponter";
        } else {
            return "calendar_day_enable";
        }
    }

    printRange = () => {
        return this.state.startDayFormated + ' - ' + this.state.endDayFormated;
    }


    setOK = () =>  { 

        this.props.setOKCalendar(this.state.startDayFormated, this.state.endDayFormated);
    }

render() { 
    
    const Week1 = this.state.w1.map((d,index) => {
        return (
            (d.disabled) ? (
                <div key={d.key} className="calendar_day_disable">{d.thisDay}</div>
            ) : (
                <CalendarCell  d={d} 
                    key={d.key}
                    startDay={this.state.startDay} 
                    endDay={this.state.endDay}
                    setDayCell={this.setDayCell} />
            )
        )
    });

    const Week2 = this.state.w2.map((d,index) => {
        return (
            (d.disabled) ? (
                <div key={d.key} className="calendar_day_disable">{d.thisDay}</div>
            ) : (
                <CalendarCell  d={d} 
                    key={d.key}
                    startDay={this.state.startDay} 
                    endDay={this.state.endDay}
                    setDayCell={this.setDayCell} />
                //<div key={d.key} className={this.getCssClass(d)}  onClick={() => this.setSelectedDate(d)} >{d.thisDay}</div>
            )
        )
    });

    const Week3 = this.state.w3.map((d,index) => {
        return (
            (d.disabled) ? (
                <div key={d.key} className="calendar_day_disable">{d.thisDay}</div>
            ) : (
                <CalendarCell  d={d} 
                    key={d.key}
                    startDay={this.state.startDay} 
                    endDay={this.state.endDay}
                    setDayCell={this.setDayCell} />
            )
        )
    });    

    const Week4 = this.state.w4.map((d,index) => {
        return (
            (d.disabled) ? (
                <div key={d.key} className="calendar_day_disable">{d.thisDay}</div>
            ) : (
                <CalendarCell  d={d} 
                    key={d.key}
                    startDay={this.state.startDay} 
                    endDay={this.state.endDay}
                    setDayCell={this.setDayCell} />
            )
        )
    });    

    const Week5 = this.state.w5.map((d,index) => {
        return (
            (d.disabled) ? (
                <div key={d.key} className="calendar_day_disable">{d.thisDay}</div>
            ) : (
                <CalendarCell  d={d} 
                    key={d.key}
                    startDay={this.state.startDay} 
                    endDay={this.state.endDay}
                    setDayCell={this.setDayCell} />
            )
        )
    });    

    const Week6 = this.state.w6.map((d,index) => {
        return (
            (d.disabled) ? (
                <div key={d.key} className="calendar_day_disable">{d.thisDay}</div>
            ) : (
                <CalendarCell  d={d} 
                    key={d.key}
                    startDay={this.state.startDay} 
                    endDay={this.state.endDay}
                    setDayCell={this.setDayCell} />
            )
        )
    });    



    return (
        <React.Fragment>
                <div className="hp_search_field_dropDown_inner_containerCalendar">
                    <div className="cntered-flex calendar">
                        <div className="calendar_container">
                            <div className="calendar_date_title">
                                <div className="cntered-flex directionRtl">
                                    {(this.state.calendarSection ===1) 
                                    ? <span>תאריך התחלה</span> : null}

                                    {(this.state.calendarSection ===2) 
                                    ? <span>תאריך סיום</span> : null}

                                    {(this.state.calendarSection ===3) 
                                    ? <span>{this.printRange()}</span> : null}
                               
                                </div>
                            </div>
                            <div className="calendar_month_title cntered-flex">
                                        
                                <span className="month_right_arrow pointer" onClick={this.prevMonth}></span>

                                {this.state.currentMonthHebName}&nbsp;{this.state.currentYear}                                

                                <span className="month_left_arrow pointer" onClick={this.nextMonth}></span>

                            </div>

                            

                                <React.Fragment>
                                    <div className="calendar_grid">
                                        <div className="calendar_day_title">א'</div>
                                        <div className="calendar_day_title">ב'</div>
                                        <div className="calendar_day_title">ג'</div>
                                        <div className="calendar_day_title">ד'</div>
                                        <div className="calendar_day_title">ה'</div>
                                        <div className="calendar_day_title">ו'</div>
                                        <div className="calendar_day_title">ש</div>
                                        
                                        {Week1}
                                        {Week2}
                                        {Week3}
                                        {Week4}
                                        {Week5}
                                        {Week6}
                                        
                                    </div>
                                </React.Fragment>
                        </div>
                    </div>
                </div>


                <div className="inline_block">
                    <div className="hp_search_field_dropDown_inner_button_ok"
                        onClick={this.setOK}>
                        <div className="title">
                            אישור
                        </div>
                    </div>

                    <div className="hp_search_field_dropDown_inner_button_clear"
                        onClick={this.resetClear}>
                        נקה
                    </div>
                </div>
            </React.Fragment>
    )
  }
}

export default Calendar;
//export  default connect()(Calendar)